<template>

  <div class="pc-menu-bar" v-if="!isMobile">
    <div class="btns">
      <div v-if="isAuthentified" class="menu-bar">
        <img class="btn xsint" src="/xsint_logo_white.png" width="10%"/>
        <div style="width: 5%;"></div>
        <nav>
          <a href="/#pricing">
          <button class="btn">
            <v-icon left>mdi-store</v-icon> Pricing
          </button>
          </a>
        
          <a href="https://osint-graph.xsint-intelligence.com/" target="_blank">
            <button class="btn" >
              <v-icon left>mdi-graphql</v-icon> Graph
            </button>
          </a>

          <button class="btn" @click="navigateTo('/lookup')">
            <v-icon left>mdi-magnify</v-icon> Lookup
          </button>
    
          <button class="btn" @click="navigateTo('/updates')">
            <v-icon left>mdi-refresh</v-icon> Updates
          </button>

              
          <button class="btn" @click="navigateTo('/discord-bot')">
            <v-icon left>mdi-robot</v-icon> Discord Bot
          </button>


        </nav>


        <button class="btn">
            &nbsp;<b>{{ userdata.research }}</b>&nbsp;<v-icon left>mdi-magnify</v-icon>
          </button>


        <div class="account-menu" 
            @mouseenter="toggleAccountMenu(true)" 
            @mouseleave="toggleAccountMenu(false)">
          <button class="btn account-btn">
            <v-icon left>mdi-account-circle</v-icon>&nbsp;{{ userdata.username }}&nbsp;&nbsp;
          </button>

          <!-- Le menu déroulant qui est visible lorsqu'on survole -->
          <div v-if="accountMenuVisible" class="dropdown-menu">
            <button class="btn" @click="navigateTo('/mysubscription')">
              <v-icon left>mdi-credit-card</v-icon> Subscription
            </button>
            <button class="btn" @click="navigateTo('/mypayments')">
              <v-icon left>mdi-credit-card-check</v-icon> Payments
            </button>
            <button class="btn" @click="logout">
              <v-icon left>mdi-logout</v-icon> Logout
            </button>
          </div>
        </div>

      </div>

      <div v-else class="menu-bar">
        <img class="btn xsint" src="/xsint_logo_white.png" width="12.5%"/>
        <div style="width: 5%;"></div>

        <nav>
            <a href="/#">
            <button class="btn">
              <v-icon left>mdi-home</v-icon> Home
            </button>
          </a>

          <a href="/#features">
            <button class="btn" >
              <v-icon left>mdi-apps</v-icon> Features
            </button>
          </a>

          <a href="/#pricing">
          <button class="btn">
            <v-icon left>mdi-store</v-icon> Pricing
          </button>
          </a>

          <a href="https://osint-graph.xsint-intelligence.com/" target="_blank">
            <button class="btn" >
              <v-icon left>mdi-graphql</v-icon> Graph
            </button>
          </a>

          <button class="btn" @click="navigateTo('/lookup')">
            <v-icon left>mdi-magnify</v-icon> Lookup
          </button>
    
           <!--<button class="btn" @click="navigateTo('/updates')">
            <v-icon left>mdi-refresh</v-icon> Updates
          </button> -->
        </nav>

        <!-- Boutons Login et Register -->
        <button class="btn" @click="navigateTo('/login')">
          <v-icon left>mdi-login</v-icon> Login
        </button>
          
        <button class="btn register-btn" @click="navigateTo('/register')">
          <v-icon left>mdi-account-plus</v-icon> Register
        </button>

      </div>
    </div>
    </div>

    <v-layout>
    <v-app-bar v-if="isMobile" class="mobile-nav-bar">
          <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
          <v-toolbar-title v-if="isAuthentified"><v-btn><img class="btn xsint" src="/xsint_logo_white.png" width="200px"/>{{ userdata.research }}<v-icon left style="width:10px">mdi-magnify</v-icon></v-btn></v-toolbar-title>
          <v-toolbar-title v-else><v-btn><img class="btn xsint" src="/xsint_logo_white.png" width="200px"/></v-btn></v-toolbar-title>
    </v-app-bar>


    <v-navigation-drawer
          v-if="isMobile"
          v-model="drawer"
          :rail="!isMobile"
          expand-on-hover
          app
          :mini-variant="isMobile" 
          color="primary"
          class="van-mobile"
        >

          <br>

          <v-list dense nav>
            <v-list-item prepend-icon="mdi-home"  title="Home" :to="{ path: '/' }"></v-list-item>
            <a href="/#pricing"><v-list-item prepend-icon="mdi-store" title="Pricing"></v-list-item></a>
            <a href="updates#1"><v-list-item prepend-icon="mdi-refresh" title="Updates" ></v-list-item></a>
            <a href="/#features"><v-list-item prepend-icon="mdi-apps" title="Features"></v-list-item></a>
            
            <v-list-subheader>Tools</v-list-subheader>

            <a href="lookup#1"><v-list-item  prepend-icon="mdi-magnify" title="Lookup"></v-list-item></a>
            <v-list-item prepend-icon="mdi-robot" title="Discord Bot" :to="{ path: '/discord-bot' }"></v-list-item>
            
            <v-list-subheader>Account</v-list-subheader>
            <div v-if="!isAuthentified">
              
              <v-list-item prepend-icon="mdi-account" title="Register" :to="{ path: '/register' }"></v-list-item>
              <v-list-item prepend-icon="mdi-login" title="Login" :to="{ path: '/login' }"></v-list-item>
            </div>

            <div v-if="isAuthentified">
              <v-list-item v-if="hasPayments" prepend-icon="mdi-account" title="My Payments" :to="{ path: '/mypayments' }"></v-list-item>
              <v-list-item v-if="hasSubscription" prepend-icon="mdi-account" title="My Subscription" :to="{ path: '/mysubscription' }"></v-list-item>
              <v-list-item prepend-icon="mdi-account" title="Logout" @click="logout()"></v-list-item>
            </div>
          </v-list>

        </v-navigation-drawer>

  </v-layout>




</template>

<script>
import { mapGetters } from 'vuex';
export default {
  data() {
      return {
        isAuthentified: localStorage.getItem('Authorization') !== null,
        userdata:  JSON.parse(localStorage.getItem('userdata')),
        isMobile: false,
        hasSubscription: JSON.parse(localStorage.getItem('userdata')) ? JSON.parse(localStorage.getItem('userdata')).hasSubscription : false,
        hasPayments: JSON.parse(localStorage.getItem('userdata')) ? JSON.parse(localStorage.getItem('userdata')).hasPayments : false,
        nberr: 0,
        drawer: false,
        accountMenuVisible: false,
        d2 : true,
      };
  },

  async created(){
    this.checkIfMobile();
    window.addEventListener('resize', this.checkIfMobile);
    if(localStorage.getItem('userdata')){
      this.startPolling();
      this.start_sv_Polling();
    }

  },

  computed: {
    ...mapGetters(['backend']),
    userResearch(){
      return `${this.userdata.research} remaining searches`;
  },

  },
  methods: {
    toggleDrawer() {
      this.d2 = !this.d2;
    },

    // Modifier la méthode pour prendre un argument (true/false) au lieu de basculer l'état
    toggleAccountMenu(show) {
      this.accountMenuVisible = show;
    },

    async logout(){
      localStorage.removeItem("Authorization");
      localStorage.removeItem("userdata");
      window.location.href = '/';
    },

    navigateTo(path) {
      // Navigation sans recharger la page
      this.$router.push(path);
    },

    async getUserData(){
      const token = localStorage.getItem("Authorization");
      console.log(this.backend);
      try{
        const response = await this.$axios.get(`${this.backend}/api/user/account`, {headers:{
          "Authorization": token
        }}
        );
        localStorage.setItem('userdata', JSON.stringify(response.data))
        const user_dat = JSON.parse(localStorage.getItem('userdata'))
        this.userdata = user_dat
        if(user_dat.hasSubscription){
          this.hasSubscription = user_dat.hasSubscription
        } 
        if(user_dat.hasPayments){
          this.hasPayments = user_dat.hasPayments
        } 
      }catch(err){
        if (this.nberr >=1){
          console.log(err)
          localStorage.removeItem('userdata');
          localStorage.removeItem('Authorization');
          this.nberr = 0
          location.reload()

        }else{
          this.nberr +=1
        }

      }
    },

    checkIfMobile() {
      this.isMobile = window.innerWidth < 1280;
    },

    getUserDataByStorage(){
      let user_dat = JSON.parse(localStorage.getItem('userdata'))
      this.userdata = user_dat 

      if(user_dat.hasSubscription){
        this.hasSubscription = user_dat.hasSubscription
      } 
      if(user_dat.hasPayments){
        this.hasPayments = user_dat.hasPayments
      } 
    },
    startPolling() {
      setInterval(async () => {
        this.getUserDataByStorage();
      }, 1000);
    },

    start_sv_Polling() {
      setInterval(async () => {
        this.getUserData();
      }, 10000);
    },

    beforeDestroy() {
      clearInterval(this.pollingInterval);
    }
  },
}
</script>



<style scoped>
.menubar-card {
  position: fixed;
  top: 0;
  width: 100%;
  max-height: 64px; 
  z-index: 5000;
}


.mobile-nav-bar{
  border-radius: 10px;
  margin-top: 5px;
  background-color: rgb(17, 17, 17) !important;
}


.menu-bar {
  display: flex;
  padding-top: 25px; /* Ajustez cela pour l'espacement interne de la barre */
  text-align: center;
  align-items: center;
  position: fixed; /* Fixe la barre en haut de la page */
  width: 100%; /* La barre prend toute la largeur */
  color: #fff; /* Texte en blanc */
  z-index: 1000; /* Assure que la barre est au-dessus du reste du contenu */


}


.btn {
  padding-right: 55px;
  font-size: 16px;
}

nav {
  flex: 1;
  text-align: center;

}

.xsint {
  padding-left: 50px;
}

.account-menu {
  position: relative;
}


.dropdown-menu {
  position: absolute;
  right: 0;
  margin-right: 2;
  background-color: rgba(0, 0, 0, 0.8);
  border-radius: 5px;
  width: 200px;

}

.dropdown-menu .btn {
  padding: 10px;
  background-color: transparent;
  color: white;
  text-align: left;
  border: none;
  width: 100%;
}

.dropdown-menu .btn:hover {
  transition: 0.4s;
  background-color: rgba(5, 122, 255, 0.5);
  border-radius: 5px;
}

.account-btn{
  background-color: rgba(0, 110, 255, 0.527);
  margin-right: 40px;
  padding: 10px;
  border-radius: 10px;

}
</style>
